import styled from 'styled-components';
import { Flex } from '@elementary/common-ui/components';

const Wrapper = styled(Flex)`
  align-items: center;
  height: 16px;
  width: 100%;
  padding: 3px;
  gap: 4px;
  border: ${({ theme }) => `1px solid ${theme.palette.common.lightBlue3}`};
  position: relative;
`;

const Segment = styled.div<{ $color: string; width: number }>`
  height: 8px;
  width: ${({ width }) => width}%;
  background-color: ${({ $color }) => $color};
`;

const Marker = styled(Flex)<{ $value: number }>`
  position: absolute;
  left: ${({ $value }) => $value}%;
  width: 4px;
  height: 27px;
  background: ${({ theme }) => theme.palette.common.jetGrey};
  border: 1px solid white;
  border-radius: 3px;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.25);
`;

type Props = {
  segmentsColors: string[];
  segmentsValues?: number[];
  markerValue?: number;
};

const SegmentedLineChart = ({
  segmentsColors,
  segmentsValues,
  markerValue,
}: Props) => (
  <Wrapper>
    {segmentsColors.map((color, index) => (
      <Segment
        key={color}
        $color={color}
        width={
          segmentsValues ? segmentsValues[index] : 100 / segmentsColors.length
        }
      />
    ))}
    {markerValue !== undefined && <Marker $value={markerValue} />}
  </Wrapper>
);

export default SegmentedLineChart;
